var _excluded = ["analyticsName", "onBlur", "onFocus"];

function cov_19d7qqdwnw() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Input/InputBase.tsx";
  var hash = "88df76e874df78e0578e5ecb3f3852190687d536";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Input/InputBase.tsx",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 18
        },
        end: {
          line: 56,
          column: 1
        }
      },
      "1": {
        start: {
          line: 16,
          column: 19
        },
        end: {
          line: 16,
          column: 49
        }
      },
      "2": {
        start: {
          line: 17,
          column: 31
        },
        end: {
          line: 17,
          column: 53
        }
      },
      "3": {
        start: {
          line: 20,
          column: 32
        },
        end: {
          line: 25,
          column: 6
        }
      },
      "4": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 32,
          column: 32
        }
      },
      "5": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 30,
          column: 7
        }
      },
      "6": {
        start: {
          line: 29,
          column: 8
        },
        end: {
          line: 29,
          column: 91
        }
      },
      "7": {
        start: {
          line: 34,
          column: 24
        },
        end: {
          line: 37,
          column: 5
        }
      },
      "8": {
        start: {
          line: 35,
          column: 6
        },
        end: {
          line: 35,
          column: 28
        }
      },
      "9": {
        start: {
          line: 36,
          column: 6
        },
        end: {
          line: 36,
          column: 90
        }
      },
      "10": {
        start: {
          line: 38,
          column: 23
        },
        end: {
          line: 41,
          column: 5
        }
      },
      "11": {
        start: {
          line: 39,
          column: 6
        },
        end: {
          line: 39,
          column: 26
        }
      },
      "12": {
        start: {
          line: 40,
          column: 6
        },
        end: {
          line: 40,
          column: 89
        }
      },
      "13": {
        start: {
          line: 42,
          column: 25
        },
        end: {
          line: 43,
          column: 89
        }
      },
      "14": {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 43,
          column: 89
        }
      },
      "15": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 54,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        },
        loc: {
          start: {
            line: 15,
            column: 57
          },
          end: {
            line: 55,
            column: 3
          }
        },
        line: 15
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 26,
            column: 14
          },
          end: {
            line: 26,
            column: 15
          }
        },
        loc: {
          start: {
            line: 26,
            column: 20
          },
          end: {
            line: 32,
            column: 5
          }
        },
        line: 26
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 34,
            column: 24
          },
          end: {
            line: 34,
            column: 25
          }
        },
        loc: {
          start: {
            line: 34,
            column: 67
          },
          end: {
            line: 37,
            column: 5
          }
        },
        line: 34
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 38,
            column: 23
          },
          end: {
            line: 38,
            column: 24
          }
        },
        loc: {
          start: {
            line: 38,
            column: 66
          },
          end: {
            line: 41,
            column: 5
          }
        },
        line: 38
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 42,
            column: 25
          },
          end: {
            line: 42,
            column: 26
          }
        },
        loc: {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 43,
            column: 89
          }
        },
        line: 43
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 30,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 30,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 28
      },
      "1": {
        loc: {
          start: {
            line: 29,
            column: 8
          },
          end: {
            line: 29,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 29,
            column: 8
          },
          end: {
            line: 29,
            column: 21
          }
        }, {
          start: {
            line: 29,
            column: 25
          },
          end: {
            line: 29,
            column: 90
          }
        }],
        line: 29
      },
      "2": {
        loc: {
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 35,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 35,
            column: 13
          }
        }, {
          start: {
            line: 35,
            column: 17
          },
          end: {
            line: 35,
            column: 27
          }
        }],
        line: 35
      },
      "3": {
        loc: {
          start: {
            line: 36,
            column: 6
          },
          end: {
            line: 36,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 6
          },
          end: {
            line: 36,
            column: 19
          }
        }, {
          start: {
            line: 36,
            column: 23
          },
          end: {
            line: 36,
            column: 89
          }
        }],
        line: 36
      },
      "4": {
        loc: {
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 39,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 39,
            column: 12
          }
        }, {
          start: {
            line: 39,
            column: 16
          },
          end: {
            line: 39,
            column: 25
          }
        }],
        line: 39
      },
      "5": {
        loc: {
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 40,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 40,
            column: 19
          }
        }, {
          start: {
            line: 40,
            column: 23
          },
          end: {
            line: 40,
            column: 88
          }
        }],
        line: 40
      },
      "6": {
        loc: {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 43,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 43,
            column: 19
          }
        }, {
          start: {
            line: 43,
            column: 23
          },
          end: {
            line: 43,
            column: 89
          }
        }],
        line: 43
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "88df76e874df78e0578e5ecb3f3852190687d536"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_19d7qqdwnw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_19d7qqdwnw();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { forwardRef } from '@chakra-ui/system';
import { useMergeRefs } from '@chakra-ui/hooks';
import { useObservabilitySafe } from '../../hooks/useObservabilitySafe';
import { bricks } from '../../system/bricks.types';
import { useStyleConfig } from '../../system/utils';
var InputBase = (cov_19d7qqdwnw().s[0]++, forwardRef(function (_ref, ref) {
  var analyticsName = _ref.analyticsName,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      props = _objectWithoutProperties(_ref, _excluded);

  cov_19d7qqdwnw().f[0]++;
  var styles = (cov_19d7qqdwnw().s[1]++, useStyleConfig('Input', props));

  var _ref2 = (cov_19d7qqdwnw().s[2]++, useObservabilitySafe()),
      trackUserEvent = _ref2.trackUserEvent; // Tracks impression events


  var _ref3 = (cov_19d7qqdwnw().s[3]++, useInView({
    // https://react-intersection-observer.vercel.app/?path=/docs/useinview-hook--basic
    // threshold: Number between 0 and 1 indicates the percentage that should be visible before triggering. (set at 100% for now)
    threshold: 1,
    skip: !analyticsName
  })),
      _ref4 = _slicedToArray(_ref3, 2),
      inViewRef = _ref4[0],
      inView = _ref4[1];

  cov_19d7qqdwnw().s[4]++;
  useEffect(function () {
    cov_19d7qqdwnw().f[1]++;
    cov_19d7qqdwnw().s[5]++;

    // this tracks impression events whenenver the input enters or leaves the viewpoint
    if (inView) {
      cov_19d7qqdwnw().b[0][0]++;
      cov_19d7qqdwnw().s[6]++;
      (cov_19d7qqdwnw().b[1][0]++, analyticsName) && (cov_19d7qqdwnw().b[1][1]++, trackUserEvent({
        inputViewEvent: {
          targetName: analyticsName
        }
      }));
    } else {
      cov_19d7qqdwnw().b[0][1]++;
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [inView, analyticsName]);
  cov_19d7qqdwnw().s[7]++;

  var handleFocus = function handleFocus(e) {
    cov_19d7qqdwnw().f[2]++;
    cov_19d7qqdwnw().s[8]++;
    (cov_19d7qqdwnw().b[2][0]++, onFocus) && (cov_19d7qqdwnw().b[2][1]++, onFocus(e));
    cov_19d7qqdwnw().s[9]++;
    (cov_19d7qqdwnw().b[3][0]++, analyticsName) && (cov_19d7qqdwnw().b[3][1]++, trackUserEvent({
      inputFocusEvent: {
        targetName: analyticsName
      }
    }));
  };

  cov_19d7qqdwnw().s[10]++;

  var handleBlur = function handleBlur(e) {
    cov_19d7qqdwnw().f[3]++;
    cov_19d7qqdwnw().s[11]++;
    (cov_19d7qqdwnw().b[4][0]++, onBlur) && (cov_19d7qqdwnw().b[4][1]++, onBlur(e));
    cov_19d7qqdwnw().s[12]++;
    (cov_19d7qqdwnw().b[5][0]++, analyticsName) && (cov_19d7qqdwnw().b[5][1]++, trackUserEvent({
      inputBlurEvent: {
        targetName: analyticsName
      }
    }));
  };

  cov_19d7qqdwnw().s[13]++;

  var onMouseEnter = function onMouseEnter() {
    cov_19d7qqdwnw().f[4]++;
    cov_19d7qqdwnw().s[14]++;
    return (cov_19d7qqdwnw().b[6][0]++, analyticsName) && (cov_19d7qqdwnw().b[6][1]++, trackUserEvent({
      inputHoverEvent: {
        targetName: analyticsName
      }
    }));
  };

  cov_19d7qqdwnw().s[15]++;
  return /*#__PURE__*/React.createElement(bricks.input, _extends({
    ref: useMergeRefs(inViewRef, ref),
    onFocus: handleFocus,
    onMouseEnter: onMouseEnter,
    onBlur: handleBlur // __css has a lower priority than sx
    ,
    __css: styles
  }, props));
}));
export default InputBase;